
<div class="imageSelector" ref="imageSelector">
  <p v-if="selectAll" class="hint">{{ $t('CONFIGURATOR_CHOOSE_ALL_HINT_ONLY_INCLUDES_DISPLAYED') }}
    <HelpTooltip inline>{{ $t("CONFIGURATOR_CHOOSE_ALL_HINT") }}</HelpTooltip>
  </p>
  <p v-if="! isReadonly" class="hint">{{ selectHintText }}</p>
  <v-sheet v-if="hasFavoriteImages" elevation="0" class="imageSheet">
    <h3 class="sectionTitle">{{ $t("FAVORITE_IMAGES") }}</h3>
    <div class="imageLayout">
      <SelectableImagePreview v-for="image in favoriteImages"
                              :key="image.uniqueId"
                              class="imageSelectionDiv"
                              :image="image"
                              :filter="filter"
                              :selected="isSelected(image)"
                              @select="onSelect(image)"/>
    </div>
  </v-sheet>
  <v-sheet elevation="5" class="imageSheet">
    <h3 v-if="hasFavoriteImages || hasRecentlyUsedImages" class="sectionTitle">{{ $t("ALL_IMAGES") }}</h3>
    <VirtualScroll class="imageLayout"
                   :active="true"
                   :items="images"
                   :initial-items-count="8"
                   :preload-padding="137"
                   :visible-window="getContainer()"
                   ref="allImages"
    >
      <template scope="{item}">
        <SelectableImagePreview class="imageSelectionDiv"
                                :image="item"
                                :filter="filter"
                                :selected="isSelected(item)"
                                @select="onSelect(item)"/>
      </template>
    </VirtualScroll>
  </v-sheet>
</div>
